import React from 'react';
import { Helmet } from 'react-helmet';
import techStackImg from '../assets/images/WebScraperPage__tech_stack.drawio.png';
import uiImg from '../assets/images/WebScraperPage__streamlit_UI.png';
import '../pages/WebScraperPage.css'

export default function WebScraperPage({ onBack }) {
  return (
    <>
      <Helmet>
        <title>Web Scraper Project | Insight Data LLC</title>
      </Helmet>
      <div className="ws-modern-home">
        <section className="ws-modern-header">
          <button onClick={onBack} className="back-link" style={{ marginBottom: '1rem' }}>
            Back to Projects
          </button>
        </section>
        <section className="ws-modern-title-section">
          <h1 className="ws-modern-title">Webscraper with AI Parsing</h1>
        </section>
        <div className="ws-modern-content">
          <div className="ws-modern-left">
            <p className="ws-modern-description">
              This is a compact web-scraping tool for local machines written in Python with Selenium and Streamlit. Optional LLM usage for content parsing.
            </p>
            <h2 className="ws-modern-subheading">Stack</h2>
            <p>Selenium, Streamlit, Python, Ollama (optional)</p>
            <h2 className="ws-modern-subheading">Acknowledgments</h2>
            <p>
              This implementation incorporates techniques from TechWithTim’s{' '}
              <a
                href="https://www.youtube.com/watch?v=Oo8-nEuDBkk&t=2082s"
                target="_blank"
                rel="noopener noreferrer"
              >
                YouTube tutorial
              </a>{' '}
              and the dynamic-scroll approach by Writer Bricks in their{' '}
              <a
                href="https://medium.com/@writerbricks/scraping-dynamic-data-that-loads-on-scroll-with-python-c4c4970a54d1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Medium article
              </a>.
              The data-cleaning and integration logic were developed exclusively for this project.
            </p>
            <div style={{ textAlign: 'right', marginTop: '1rem' }}>
              <a
                href="https://github.com/jakobjgu/web-scraper"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0039A6', fontSize: '0.95rem', fontWeight: 500 }}
              >
                View GitHub Repo
              </a>
            </div>
          </div>
          <div className="ws-modern-right">
            <div className="ws-modern-image-card">
              <h3>Tech Stack</h3>
              <img
                src={techStackImg}
                alt="Tech Stack"
                className="ws-modern-image"
              />
            </div>
            <div className="ws-modern-image-card">
              <h3>UI Example</h3>
              <img
                src={uiImg}
                alt="Streamlit UI Example"
                className="ws-modern-image"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
